/* @flow */

import * as React from 'react';

import './calendar-year-picker.module.css';

type Props = {|
    onChange: (number) => void,
    year: ?number,
    isLightMode?: ?boolean,
|};

export const CalendarYearPicker = (props: Props) => {
    const [isButton, setIsButton] = React.useState<boolean>(true);
    const [yearInput, setYearInput] = React.useState<?number>(props.year);

    React.useEffect(() => {
        setYearInput(props.year);
    }, [props.year]);

    const handleButtonClick = (e) => {
        e.stopPropagation();
        setIsButton(false);
    };

    const handleSubmit = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        setIsButton(true);

        if (yearInput) {
            const fourDigitYear = yearInput < 100 ? Number(yearInput) + 2000 : yearInput;
            props.onChange(fourDigitYear);
        }
    };

    if (isButton) {
        return (
            <button
                styleName={props.isLightMode ? 'button-light' : 'button'}
                onClick={handleButtonClick}
            >
                {props.year}
            </button>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <input
                styleName='input'
                name='year'
                type='number'
                onChange={(e) => setYearInput(e.target.value)}
                onBlur={handleSubmit}
                value={yearInput}
                autoFocus={true}
            />
        </form>
    );
};
